// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"313":"core-components-deferred","511":"core-components","870":"vendors-editor","985":"vendors-extra"}[chunkId] || chunkId) + "." + {"277":"82f8df50","313":"f3798c60","511":"d374bf87","870":"808d04aa","985":"34920990"}[chunkId] + ".chunk.js";
};